import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import ServicesGroup from './ServicesGroup/ServicesGroup';
import { initI18n } from '../../utils';
import ServicesAggregationProvider from '../context';
initI18n('ServiceAggregation');
const ServiceAggregation = ({ serviceGroups, userInfo, refetchUser }) => {
    const theme = useTheme('ServiceAggregation').ServiceAggregation;
    const { t } = useTranslation('ServiceAggregation');
    return (React.createElement(ServicesAggregationProvider, { userInfo: userInfo, refetchUser: refetchUser },
        React.createElement("div", { className: theme.container },
            React.createElement("div", { className: theme.header }, t('Plan your trip')),
            React.createElement("div", null, serviceGroups.map(group => {
                return (React.createElement(ServicesGroup, { key: group.type, icon: group.icon, directionLabel: group.directionLabel, timePeriod: group.timePeriod, className: theme.group, description: group.description, empty: group.empty }, group.services));
            })))));
};
export default ServiceAggregation;
